package com.eladfinish.bible.contest.ui.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.Surface
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.background_parchment
import dev.icerock.moko.resources.compose.painterResource

@Composable
internal fun ParchmentBackground(
    screenContent: @Composable () -> Unit,
) {
    Surface(
        modifier = Modifier.fillMaxSize()
    ) {
        Image(
            painter = painterResource(SharedRes.images.background_parchment),
            contentDescription = null,
            modifier = Modifier.fillMaxSize(),
            contentScale = ContentScale.FillBounds
        )
        screenContent()
    }
}
